(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.productebotiga')
    .factory('ProducteBotigaFactory', ProducteBotigaFactory);

  function ProducteBotigaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'productesbotiga';

    var ProducteBase = {
      getAll: function(){
        return DataFactory.get(api);
      },
      getProductesBotigaEntitats: function(){
        var url = api + '/productebotigaentitats';
        return DataFactory.get(url);
      }
    };
    return ProducteBase;
  }
}());
